import intl from 'react-intl-universal'

import template from './media-picker-template.html'

function directive() {
  return {
    replace: true,
    restrict: 'E',
    controllerAs: 'vm',
    bindToController: true,
    template,
    scope: {
      name: '@',
      required: '@',
      type: '@',
      value: '@',
      onMediaAction: '&',
    },
    controller: ['$rootScope', 'thirdPartyIntegrationService', Controller],
  }
}

function Controller($rootScope, thirdPartyIntegrationService) {
  this.intl = intl

  this.handleAction = (action, data) => {
    this.onMediaAction({
      payload: {
        type: this.type,
        name: this.name,
        action,
        data,
      },
    })
  }
}

export default [directive]
